import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import {
  ADDRESS_CHANGE_UPDATE_CONTENTS_VALUES,
  DESTINATION_VALUES,
  CANCELLATION_REASON_VALUES,
  ESTATE_TYPE_VALUES,
  REQUIRED_TYPE_VALUES,
  NEW_INSURANCE_LINE_VALUES,
  NEW_INSURANCE_SECTION,
  DETAIL_CANCEL_REASON,
  DELETE_FLAG_TYPE,
} from 'const';
import { convertToJapaneseCalendar } from 'utils/japaneseCalendarConverter';
import { isNullOrUndefined, editTel } from 'utils/utils'
import { getStylesBackgroundColor} from 'views/Detail/components';
import { getStylesLabelColorLine} from 'views/Detail/components';

const CancellationDetail = (props) => {
  const { insuranceType, cancellation } = props;


  return (
    <Card>
      <CardHeader
        title='解約'
        className={getStylesBackgroundColor(insuranceType)}
      />
      <CardContent className={styles.cardContent}>
        <div className={styles.cancellationInformation}>
          <Grid container spacing={5}>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>解約希望日</p>
                <p className={styles.text}>
                  {convertToJapaneseCalendar(cancellation?.cancellationDate) || '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>解約理由</p>
                <p className={styles.text}>
                  {cancellation?.cancellationReason
                    ? CANCELLATION_REASON_VALUES[
                        cancellation.cancellationReason
                      ]
                    : '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>解約理由詳細</p>
                <p className={styles.text}>
                  {cancellation?.isCancellationForUnify
                    ? DETAIL_CANCEL_REASON[cancellation.isCancellationForUnify]
                    : '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>具体的な解約理由</p>
                <p className={styles.text}>
                  {cancellation?.cancellationReasonText || '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>事由発生日</p>
                <p className={styles.text}>
                  {convertToJapaneseCalendar(cancellation?.occurrenceDate) || '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>中断証明要否</p>
                <p className={styles.text}>
                  {cancellation?.isCertificateRequired
                    ? REQUIRED_TYPE_VALUES[cancellation.isCertificateRequired]
                    : '-'}
                </p>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>契約区分</p>
                <p className={styles.text}>
                  {cancellation?.newInsuranceSection
                    ? NEW_INSURANCE_SECTION[cancellation.newInsuranceSection]
                    : '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>新契約の保険種類</p>
                <p className={styles.text}>
                  {cancellation?.newInsuranceLine
                    ? NEW_INSURANCE_LINE_VALUES[cancellation.newInsuranceLine]
                    : '-'}
                </p>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>物件種類</p>
                <p className={styles.text}>
                  {cancellation?.estateType
                    ? ESTATE_TYPE_VALUES[cancellation.estateType]
                    : '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>変更対象</p>
                <p className={styles.text}>
                  {cancellation?.updateContents
                    ? ADDRESS_CHANGE_UPDATE_CONTENTS_VALUES[
                        cancellation.updateContents
                      ]
                    : '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>書類発送先選択</p>
                <p className={styles.text}>
                  {cancellation?.destination
                    ? DESTINATION_VALUES[cancellation.destination]
                    : '-'}
                </p>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>転居日</p>
                <p className={styles.text}>{convertToJapaneseCalendar(cancellation?.movingDay) || '-'}</p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>書類発送先郵便番号</p>
                <p className={styles.text}>
                  {cancellation?.destZipCode || '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>書類発送先住所</p>
                <p className={styles.text}>
                  {(cancellation?.destPrefecture || '') +
                    (cancellation?.destCity || '') +
                    (cancellation?.destChome || '') +
                    '　' +
                    (cancellation?.destBuilding || '') || '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>書類発送先住所（カナ）</p>
                <p className={styles.text}>
                  {(cancellation?.destPrefectureKana || '') +
                    (cancellation?.destCityKana || '') +
                    (cancellation?.destChomeKana || '') +
                    '　' +
                    (cancellation?.destBuildingKana || '') || '-'}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>書類発送先宛名</p>
                <p className={styles.text}>
                  {cancellation?.deliveryName || '-'}
                </p>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>新電話番号</p>
                <p className={styles.text}>
                  {editTel(cancellation?.newTel1,
                    cancellation?.newTel2,
                    cancellation?.newTel3)}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>現在の登録電話番号削除</p>
                <p className={styles.text}>
                  {
                    isNullOrUndefined(cancellation?.deleteTelFlg)
                    ? "-"
                    : DELETE_FLAG_TYPE[cancellation?.deleteTelFlg ? 1 : 0]
                  }
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>新携帯電話番号</p>
                <p className={styles.text}>
                  {editTel(cancellation?.newMobileTel1,
                    cancellation?.newMobileTel2,
                    cancellation?.newMobileTel3)}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>現在の登録携帯電話番号削除</p>
                <p className={styles.text}>
                  {
                      isNullOrUndefined(cancellation?.deleteMobileTelFlg)
                      ? "-"
                      : DELETE_FLAG_TYPE[cancellation?.deleteMobileTelFlg ? 1 : 0]
                  }
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

CancellationDetail.propTypes = {
  className: PropTypes.string,
};

export default CancellationDetail;
